<app-one-time-segment
    *ngIf="segmentData?.isOneTimeSegment"
    [canAddRow]="false"
    [rowData]="data"
    [segmentData]="segmentData"
    [dialogRef]="dialogRef"
    [hideRate]="true"
/>
<app-recurring-segment
    *ngIf="segmentData?.isOneTimeSegment === false"
    [rowData]="data"
    [segmentData]="segmentData"
    [dialogRef]="dialogRef"
/>
